import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import { addEventListener } from 'ThreeTerminal_base/base';
import { InformationFlow, QQShare } from 'ThreeTerminal_mobile';
import { h5PageCount, handleCallNewsApp } from 'ThreeTerminal_utils';
import Grounds from 'ThreeTerminal_base/grounds';
import worldArea from '../../worldMap/worldArea';
import SlidesTabs from './slidesTabs';
import Map from './map';
import Sankey from './sankey';
import Line from './line';
import Intro from './intro';
class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        data: {},
        current: null,
        introShow: false,
        isAll: false,
        tabShow: false,
        areaType: 'area',
        currentPath: 'maps',
    };

    async componentDidMount() {
        const { areaCode } = this.state;
        const {
            content: { base62Id, devicetype },
        } = this.props;

        this.unHandleScroll = addEventListener(window, 'scroll', this.handleScroll);

        if (devicetype === 'share') {
            // 分享页统计
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${base62Id}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        } else if (devicetype === 'client') {
            Grounds.pageStat({
                id: `special_ucms_${base62Id}`,
                type: 'other',
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            });
        }

        this.setState({
            data: { ...this.getListData(areaCode) },
        });
    }

    componentWillUnmount() {
        this.unHandleScroll();
    }

    // 兼容 ie7 的 offsetTop 获取方法
    getOffsetTop = id => {
        const dom = document.getElementById(`${id}`);
        const offsetTop = dom.offsetTop - 200;

        return offsetTop;
    };

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        let currentPath = 'maps';

        if (currentTop > this.getOffsetTop('source')) {
            currentPath = 'source';
        }

        if (currentTop > this.getOffsetTop('lines')) {
            currentPath = 'lines';
        }

        if (currentTop > this.getOffsetTop('list')) {
            currentPath = 'list';
        }

        this.setState({
            currentPath,
            tabShow: currentTop > 100,
        });
    };

    getListData = () => {
        const {
            content: {
                yiqing_v2: { dataList, timestamp },
                shuruData: { add, total },
            },
        } = this.props;

        let result = {};

        try {
            const date = new Date(Number(timestamp));

            const Y = date.getFullYear();
            const M = date.getMonth() + 1;
            const D = date.getDate();
            const h = date.getHours();
            const m = date.getMinutes();

            const time = `截止 ${Y}.${M}.${D} ${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}`;

            const data = dataList;

            if (data) {
                const all = data.filter(item => item.name1 === '全国');

                const list = data
                    .filter(item => item.name1 === '国外')[0]
                    .child.sort((a, b) => {
                        const num1 = Number(a.quezhen);
                        const num2 = Number(b.quezhen);

                        return num2 - num1;
                    });

                let quezhen_add = 0;
                let quezhen = 0;
                let zhiyu = 0;
                let siwang = 0;

                let jnIndex = 0;
                let gzIndex = 0;

                list.forEach((item, index) => {
                    quezhen_add += Number(item.quezhen_add && item.quezhen_add !== '待公布' ? item.quezhen_add : 0);
                    quezhen += Number(item.quezhen);
                    zhiyu += Number(item.zhiyu);
                    siwang += Number(item.siwang);

                    if (item.name2 === '日本') {
                        jnIndex = index;
                    }

                    if (item.name2 === '钻石公主号') {
                        gzIndex = index;
                    }

                    if (item.child) {
                        const unknow = item.child.filter(item => item.name2.indexOf('未明确') > -1);

                        item.child = item.child
                            .filter(item => item.name2.indexOf('未明确') === -1)
                            .sort((a, b) => {
                                const num1 = Number(a.quezhen);
                                const num2 = Number(b.quezhen);

                                return num2 - num1;
                            })
                            .concat(unknow);
                    }
                });

                const jnData = list[jnIndex];

                list.splice(gzIndex, 0, jnData);

                list.forEach((item, index) => {
                    if (item.name2 === '日本') {
                        jnIndex = index;
                    }
                });

                list.splice(jnIndex, 1);

                result = {
                    time,
                    all,
                    list,
                };

                let title = '中国境外输入病例实时动态';

                if (add && total) {
                    title = `中国境外输入病例实时动态：新增${add}例 累计输入${total}例`;
                }

                if (document.querySelector('#ifeng_share_title')) {
                    document.querySelector('#ifeng_share_title').innerText = title;
                }
            }
        } catch (error) {
            console.error(error);
        }

        return result;
    };

    // 判断是否是微信
    isWeixin = () => {
        const ua = typeof navigator === 'object' ? navigator.userAgent : '';

        return ua.match(/MicroMessenger/gi);
    };

    // 判断是否是客户端
    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    handleTabChange = currentPath => {
        this.setState({
            currentPath,
        });
    };

    handleDataTabChange = type => {
        this.setState({
            areaType: type,
        });
    };

    handleTimeLineShow = () => {
        const { isAll } = this.state;

        this.setState({
            isAll: !isAll,
        });
    };

    handleIntroShow = () => {
        document.querySelector('html').style.overflow = 'hidden';
        document.querySelector('body').style.overflow = 'hidden';

        this.setState({
            introShow: true,
        });
    };

    handleMaskHide = e => {
        e.stopPropagation();

        if (e.target.id !== 'mask' && e.target.id !== 'close') {
            return;
        }

        document.querySelector('html').style.overflow = 'auto';
        document.querySelector('body').style.overflow = 'auto';

        this.setState({
            introShow: false,
        });
    };

    goBack = () => {
        window.history.back();
    };

    handleExpand = (index, name) => {
        if (Object.keys(worldArea).indexOf(name) === -1 || name === '钻石公主号') {
            return;
        }

        const { current } = this.state;

        this.setState(
            {
                current: index === current ? null : index,
            },
            () => {
                const dom = document.querySelectorAll('[data-expand]')[index];

                scrollTo(0, dom.offsetTop - 80);
            },
        );
    };

    getExpand = (index, child) => {
        const { current } = this.state;

        if (current === index) {
            return child ? (
                <div className={styles.expandtr_box}>
                    {child.map((item, k) => (
                        <div key={k} className={styles.expandtr}>
                            <span>{item.name3}</span>
                            <span>{item.quezhen_add || 0}</span>
                            <span>{item.quezhen || 0}</span>
                            <span>{item.zhiyu || 0}</span>
                            <span>{item.siwang || 0}</span>
                        </div>
                    ))}
                </div>
            ) : (
                <div className={styles.expandtr}>
                    <p>暂无统计数据</p>
                </div>
            );
        }

        return '';
    };

    handleClick = () => {
        const {
            content: { base62Id },
        } = this.props;

        h5PageCount([
            {
                behavior: 'action',
                type: 'topic',
                other: {
                    id: `special_ucms_${base62Id}`,
                    url: encodeURIComponent(location.href),
                    ref: encodeURIComponent(document.referrer),
                },
            },
        ]);

        const nodata = '';
        const doc_type = 'topic3';
        const aid = '7vfE1xavMcS';
        const to_url = 'https://news.ifeng.com/c/special/7vfE1xavMcS';
        const downloads = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1450306105889',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8791',
        };

        handleCallNewsApp(nodata, doc_type, aid, to_url, 0, 0, 'inter_fxyzt02', { noPrefixKind: true }, downloads);
    };

    getInfoUrl = code => {
        const {
            content: { devicetype },
        } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = `https://ishare.ifeng.com/c/s/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else if (devicetype === 'client') {
            url = `https://news.ifeng.com/c/specialClient/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else {
            url = `https://news.ifeng.com/c/special/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = `https://news.ifeng.com/c/vivo/7uLyp1412jw?code=${code}`;
        }

        return url;
    };

    getChinaUrl = () => {
        const {
            content: { devicetype },
        } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = 'https://ishare.ifeng.com/c/s/7tPlDSzDgVk?needpage=1&webkit=1';
        } else if (devicetype === 'client') {
            url = 'https://news.ifeng.com/c/specialClient/7tPlDSzDgVk?needpage=1&webkit=1';
        } else {
            url = 'https://news.ifeng.com/c/special/7tPlDSzDgVk?needpage=1&webkit=1';
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = 'https://news.ifeng.com/c/vivo/7tPlDSzDgVk';
        }

        return url;
    };

    render() {
        const {
            data,
            data: { time, all, list },
            introShow,
            tabShow,
            currentPath,
        } = this.state;
        const {
            content,
            content: {
                customization: { extraData },
                shuruData: { dataList, add, total, outputList, dataMap, outputList_sorted, inputList_sorted },
            },
        } = this.props;

        const inputList = {};

        if (inputList_sorted) {
            [...inputList_sorted]
                .reverse()
                .filter(item => item.name2 !== '中国')
                .forEach(item => {
                    inputList[item.name2] = item.total;
                });
        }

        const oputList = {};

        if (outputList_sorted) {
            [...outputList_sorted]
                .reverse()
                .filter(item => item.total && item.outputName !== '未明确')
                .forEach(item => {
                    oputList[item.outputName] = item.total;
                });
        }

        const tabs = [
            {
                title: '飞行地图',
                url: '#maps',
                searchPath: 'maps',
            },
            {
                title: '输入疫情',
                url: '#source',
                searchPath: 'source',
            },
            {
                title: '疫情趋势',
                url: '#lines',
                searchPath: 'lines',
            },
            {
                title: '确诊病例',
                url: '#list',
                searchPath: 'list',
            },
        ];

        const devicetype = content.devicetype;

        const isClient = this.isClient();

        let isCallup = devicetype !== 'pc' && !isClient;

        const url = window.location.href;

        let downloadShow = true;
        let isShowVivoReturnBotton = false;

        if (devicetype === 'pc' || isClient) {
            downloadShow = false;
        }

        if (url.indexOf('srctag') > -1) {
            isCallup = false;
            downloadShow = false;
            isShowVivoReturnBotton = true;
        }

        const qqShareCofig = {
            title:
                add && total ? `中国境外输入病例实时动态：新增${add}例 累计输入${total}例` : '中国境外输入病例实时动态',
            img: content.shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: content.introduction || '',
            cb: () => {
                console.log('分享成功');
            },
        };

        return (
            <div className={styles.layout}>
                <QQShare content={qqShareCofig} />
                {tabShow && devicetype !== 'pc' && (
                    <SlidesTabs
                        content={tabs}
                        currentPath={currentPath}
                        showShadow
                        handleTabChange={this.handleTabChange}
                    />
                )}
                <a id="maps" />
                <div className={styles.banner}>
                    <img
                        src="https://x0.ifengimg.com/ucms/2020_40/14AB6254B3A282DE76A5809DA80A72BF039749BD_w1125_h483.png"
                        alt=""
                    />
                    {isCallup && (
                        <div className={styles.enter} onClick={this.handleClick}>
                            <span>关注更多实时疫情</span>
                            <span />
                        </div>
                    )}
                    <div className={styles.bottom_bar} />
                </div>
                <div className={styles.data_header}>
                    <div className={styles.tab_box}>
                        <div>境外输入病例</div>
                        <a href={this.getChinaUrl()}>
                            <span>点击查看中国疫情</span>
                        </a>
                    </div>
                    <div className={styles.area_box}>
                        <div>
                            <span>新增</span>
                            <span>{add || 0}</span>
                            <span> 例</span>
                        </div>
                        <div>
                            <span>累计</span>
                            <span>{total || 0}</span>
                            <span> 例</span>
                        </div>
                    </div>
                    <div className={styles.time}>
                        <span>
                            <span>{time}</span>
                        </span>
                    </div>
                </div>
                {all && list && outputList && (
                    <Map data={data} gpsData={extraData} outputList={outputList} devicetype={devicetype} />
                )}
                <div className={styles.title_box3}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        <span>境外输入确诊病例来源</span>
                    </span>
                </div>
                <a id="source" />
                {dataMap && outputList_sorted && inputList_sorted && (
                    <Sankey data={dataMap} outputList={outputList_sorted} inputList={inputList_sorted} />
                )}
                <a id="lines" />
                <div className={styles.title_box3}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        <span>境外输入疫情趋势</span>
                    </span>
                </div>
                {dataList && <Line data={dataList} />}
                <a id="list" />
                <div className={styles.title_box3}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        <span>境外输入确诊病例</span>
                    </span>
                </div>
                {inputList_sorted && inputList_sorted.filter(item => item.name2 === '中国').length > 0 && (
                    <div className={styles.data_box}>
                        <span>{`* 由于早期公开报道不全，有 ${
                            inputList_sorted.filter(item => item.name2 === '中国')[0].total
                        } 例数据缺失`}</span>
                    </div>
                )}
                <div className={styles.data_box}>
                    <div className={styles.thead}>
                        <span>省市</span>
                        <span>累计输出</span>
                        {Object.keys(inputList).map(item => (
                            <span key={item}>{item}</span>
                        ))}
                    </div>
                    <div className={styles.tbody}>
                        <div className={styles.tbody_tr}>
                            <span>累计输入</span>
                            {Object.keys(oputList).map(item => (
                                <span key={item}>{item}</span>
                            ))}
                        </div>
                        <div className={styles.tbody_tl}>
                            <span>-</span>
                            {Object.keys(oputList).map(i => (
                                <span key={i}>{oputList[i] || '-'}</span>
                            ))}
                        </div>
                        {Object.keys(inputList).map(item => (
                            <div key={item} className={styles.tbody_tl}>
                                <span>{inputList[item]}</span>
                                {Object.keys(oputList).map(i => (
                                    <span key={i}>{dataMap[item][i] || '-'}</span>
                                ))}
                            </div>
                        ))}
                    </div>
                    <div className={styles.thmask} />
                </div>
                <div className={isCallup ? styles.info_box0 : styles.info_box1}>
                    <img src="https://x0.ifengimg.com/ucms/2020_07/0B46330073E1B16C3A3ED106B46A77A4FC8E7908_w1125_h204.png" />
                </div>
                {downloadShow && (
                    <div className={styles.download}>
                        <a href={this.getChinaUrl()}>
                            <span>中国疫情地图</span>
                        </a>
                        <div onClick={this.handleClick}>
                            <span>境外输入疫情</span>
                        </div>
                    </div>
                )}
                {isShowVivoReturnBotton && (
                    <div className={styles.return_icon} onClick={this.goBack}>
                        返回
                    </div>
                )}
                {introShow && (
                    <div
                        id="mask"
                        className={styles.mask}
                        style={{ fontSize: document.body.style.fontSize }}
                        onClick={this.handleMaskHide}>
                        <Intro handleMaskHide={this.handleMaskHide} />
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(Layout);
